export const ALL_ELEMENTS = 'ALL_ELEMENTS';
export const ADD_ELEMENT = 'ADD_ELEMENT';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ADD_RECORD = 'ADD_RECORD';
export const ERROR_RECORD = 'ERROR_RECORD';
export const ALL_RECORDS = 'ALL_RECORDS';
export const ERROR_RECORDS = 'ERROR_RECORDS';
export const FORM_FALSE = 'FORM_FALSE';
export const FORM_TRUE = 'FORM_TRUE';
export const ELEMENTS_FALSE = 'ELEMENTS_FALSE';
